import { links } from "#/shared/constants"

import LearnSectionContainer from "./LearnSectionContainer"
import LearnSectionPost, { LearnSectionPostProps } from "./LearnSectionPost"

type LearnSectionUsefulPostsProps = {
  posts: LearnSectionPostProps[]
}

export default function LearnSectionUsefulPosts({
  posts,
}: LearnSectionUsefulPostsProps) {
  return (
    <LearnSectionContainer
      title="Useful posts"
      buttonText="Visit blog"
      buttonProps={{
        href: links.BLOG,
        target: "_blank",
        "data-attr": "visit_blog",
      }}
    >
      {posts.map(({ image, title, content, href }) => (
        <LearnSectionPost
          key={title}
          image={image}
          title={title}
          content={content}
          href={href}
        />
      ))}
    </LearnSectionContainer>
  )
}
